module.exports = __webpack_public_path__ + "img/alarm.06f88e14.png";